
const msToTime = (duration) => {
  let seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = (hours < 10) ? `0${hours}` : hours;
  minutes = (minutes < 10) ? `0${minutes}` : minutes;
  seconds = (seconds < 10) ? `0${seconds}` : seconds;

  return `${hours}:${minutes}:${seconds}`;
};

const state = {
  ms: +localStorage.getItem('timer'),
  date: localStorage.getItem('date'),
};

const getters = {
  getTimer(state) {
    return state.ms;
  },
  getDate(state) {
    return state.date;
  },
  getTime(state) {
    return msToTime(state.ms);
  },
};

const actions = {
  setTimer({ commit }, ms) {
    commit('setTimer', ms);
  },
  setDate({ commit }, date) {
    localStorage.setItem('date', date);
    commit('setDate', date);
  },
};

const mutations = {
  setTimer(state, ms) {
    state.ms = ms;
    localStorage.setItem('timer', ms);
  },
  setDate(state, date) {
    state.date = date;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
